import { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { ChoiceButton, ChoiceButtonBaseIcon } from "../../../../../../shared/ChoiceButton";

const Strong = styled.strong`
	font-size: 20px;
	font-weight: ${({ theme }) => theme.fonts.weights.bold};
	padding: ${({ theme }) => theme.spacing(2)} 0;
	display: inline-block;
`;

const AlternativeTravelPlanningChoiceButtonGroup = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	gap: ${({ theme }) => theme.spacing(2)};

	${({ theme }) => theme.breakpoints.mobile} {
		grid-auto-flow: column;
		grid-auto-columns: 1fr;
	}
`;

interface Props {
	title?: string;
	canCreateTravelInquiries: boolean;
	canSelfTravel: boolean;
	onInquiry: () => void;
	onSelfTravel: () => void;
	travelSegmentButton?: ReactNode;
}

export const AlternativeTravelPlanningChoiceButtons: FC<Props> = ({
	title,
	canCreateTravelInquiries,
	canSelfTravel,
	onInquiry,
	onSelfTravel,
	travelSegmentButton,
}) => {
	const { t } = useTranslation();
	const hasAlternatives = canCreateTravelInquiries || canSelfTravel || Boolean(travelSegmentButton);

	if (!hasAlternatives) {
		return null;
	}

	return (
		<div>
			{title && <Strong>{title}</Strong>}
			<AlternativeTravelPlanningChoiceButtonGroup>
				{canCreateTravelInquiries && (
					<ChoiceButton type="button" onClick={onInquiry}>
						<ChoiceButtonBaseIcon src="/icons/checked_bag_question.svg" />
						{t("I would like to make a travel inquiry")}
					</ChoiceButton>
				)}
				{canSelfTravel && (
					<ChoiceButton type="button" onClick={onSelfTravel}>
						<ChoiceButtonBaseIcon src="/icons/edit_note.svg" />
						{t("I organize my travel on my own")}
					</ChoiceButton>
				)}
				{travelSegmentButton}
			</AlternativeTravelPlanningChoiceButtonGroup>
		</div>
	);
};
